export default "__VITE_ASSET__ca6f259a__"